import { defineCustomElement } from 'vue';
import PesquisaGeral from '../../../src/shared/pesquisa-geral/Index.vue';

if (!customElements.get('pesquisa-geral')) {
  const PesquisaGeralElement = defineCustomElement(PesquisaGeral, { shadowRoot: false });
  customElements.define('pesquisa-geral', PesquisaGeralElement);
}
